const { JIT_SUPPORTED_PROTOCOLS } = require('@silverfort-nodelibs/common/utils/consts');

exports.TIER_SCOPES = { IN_SCOPE: 'included', OUT_SCOPE: 'excluded', DCS: 'dcs' };
exports.SCOPES_TITLE = {
    [this.TIER_SCOPES.IN_SCOPE]: 'In scope',
    [this.TIER_SCOPES.OUT_SCOPE]: 'Out of scope'
};
exports.SCOPES_COLOR = {
    [this.TIER_SCOPES.IN_SCOPE]: 'bg-sf-positive-500',
    [this.TIER_SCOPES.OUT_SCOPE]: 'bg-sf-negative-500'
};

exports.SCOPE_SHOW_SERVICES = {
    [this.TIER_SCOPES.IN_SCOPE]: true,
    [this.TIER_SCOPES.OUT_SCOPE]: false,
    [this.TIER_SCOPES.DCS]: true
};

// Default protocols per resource type
exports.DEFAULT_PROTOCOLS_AD = [JIT_SUPPORTED_PROTOCOLS.KERBEROS, JIT_SUPPORTED_PROTOCOLS.NTLM, JIT_SUPPORTED_PROTOCOLS.DESKTOP];
exports.DEFAULT_PROTOCOLS_IP = [JIT_SUPPORTED_PROTOCOLS.LDAP, JIT_SUPPORTED_PROTOCOLS.LDAPS];
